{
  "metadata": {
    "id": "synthesis-dark",
    "name": "Synthesis",
    "description": "Собственная тема Synth «Synthesis» (dark)",
    "author": "Synth",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "synth",
      "own"
    ],
    "source": {
      "file": "tools/lib/make_themes.py",
      "project": "synth",
      "url": null,
      "upstreamFile": null,
      "license": "собственная (Synth)",
      "authoring": "tools/lib/make_themes.py"
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.0,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.466,
      "paletteMaxS": 0.516,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 20.2,
      "syntaxVsTextMinDeltaE": 24.2,
      "chartsMinDeltaE": 31.2,
      "textSeparationDeltaE": 24.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#CA6008",
      "hover": "#d07326",
      "active": "#d58039",
      "foreground": "#000000",
      "muted": "#ca600880",
      "emphasis": "#CA6008"
    },
    "surface": {
      "background": "#1C1917",
      "foreground": "#E7E5E4",
      "muted": "#302d2b",
      "mutedForeground": "#a8a29e",
      "elevated": "#393634",
      "elevatedForeground": "#E7E5E4",
      "raised": "#514e4c",
      "raisedForeground": "#E7E5E4",
      "overlay": "#1c1917cc",
      "subtle": "#272422"
    },
    "interactive": {
      "border": "#53504f",
      "borderHover": "#555250",
      "borderFocus": "#CA6008",
      "selection": "#e7e5e429",
      "selectionForeground": "#E7E5E4",
      "focus": "#ca600859",
      "focusRing": "#ca600861",
      "cursor": "#fafaf9",
      "hover": "#e7e5e41c",
      "active": "#e7e5e429"
    },
    "status": {
      "error": "#d55c51",
      "errorForeground": "#000000",
      "errorBackground": "#d55c5124",
      "errorBorder": "#d55c5173",
      "warning": "#D0A215",
      "warningForeground": "#000000",
      "warningBackground": "#d0a21524",
      "warningBorder": "#d0a21573",
      "success": "#879A39",
      "successForeground": "#000000",
      "successBackground": "#879a3924",
      "successBorder": "#879a3973",
      "info": "#3AA99F",
      "infoForeground": "#000000",
      "infoBackground": "#3aa99f24",
      "infoBorder": "#3aa99f73"
    },
    "pr": {
      "open": "#879A39",
      "draft": "#ada7a3",
      "blocked": "#D0A215",
      "merged": "#DA702C",
      "closed": "#d55c51"
    },
    "syntax": {
      "base": {
        "background": "#3f3c3a",
        "foreground": "#E7E5E4",
        "comment": "#c9a082",
        "keyword": "#A0B347",
        "string": "#3fb8ad",
        "number": "#d29f5b",
        "function": "#fa8d4c",
        "variable": "#E7E5E4",
        "type": "#D0A215",
        "operator": "#ada7a3"
      },
      "tokens": {
        "commentDoc": "#c9a082",
        "stringEscape": "#ada7a3",
        "keywordImport": "#A0B347",
        "storageModifier": "#A0B347",
        "functionCall": "#fa8d4c",
        "method": "#fa8d4c",
        "variableProperty": "#fa8d4c",
        "variableOther": "#E7E5E4",
        "variableGlobal": "#d29f5b",
        "variableLocal": "#ada7a3",
        "parameter": "#E7E5E4",
        "constant": "#d29f5b",
        "class": "#D0A215",
        "className": "#D0A215",
        "interface": "#D0A215",
        "struct": "#D0A215",
        "enum": "#D0A215",
        "typeParameter": "#D0A215",
        "namespace": "#D0A215",
        "module": "#A0B347",
        "tag": "#A0B347",
        "jsxTag": "#A0B347",
        "tagAttribute": "#fa8d4c",
        "tagAttributeValue": "#3fb8ad",
        "boolean": "#d29f5b",
        "decorator": "#A0B347",
        "label": "#fa8d4c",
        "regexp": "#3fb8ad"
      }
    },
    "charts": {
      "series": [
        "#CA6008",
        "#3AA99F",
        "#879A39",
        "#D0A215",
        "#d55c51"
      ]
    },
    "chat": {
      "background": "#1C1917",
      "userMessage": "#E7E5E4",
      "userMessageBackground": "#393634",
      "assistantMessage": "#E7E5E4",
      "assistantMessageBackground": "#302d2b",
      "timestamp": "#ada7a3",
      "divider": "#53504f",
      "typing": "#ada7a3"
    },
    "loading": {
      "spinner": "#CA6008",
      "spinnerTrack": "#302d2b",
      "skeleton": "#302d2b",
      "shimmer": "#494644"
    },
    "tools": {
      "background": "#302d2b",
      "border": "#53504f",
      "headerHover": "#474442",
      "icon": "#d96709",
      "title": "#E7E5E4",
      "description": "#ada7a3",
      "edit": {
        "added": "#879A39",
        "addedBackground": "#879a3924",
        "removed": "#d55c51",
        "removedBackground": "#d55c5124",
        "modified": "#3AA99F",
        "modifiedBackground": "#3aa99f24",
        "lineNumber": "#ada7a3"
      }
    },
    "markdown": {
      "heading1": "#E7E5E4",
      "heading2": "#E7E5E4",
      "heading3": "#E7E5E4",
      "heading4": "#E7E5E4",
      "link": "#cf6208",
      "linkHover": "#d07326",
      "inlineCode": "#3fb8ad",
      "inlineCodeBackground": "#302d2b",
      "blockquote": "#ada7a3",
      "blockquoteBorder": "#53504f",
      "listMarker": "#cf6208",
      "bold": "#E7E5E4",
      "italic": "#e7e5e4e6",
      "strikethrough": "#ada7a3",
      "hr": "#53504f"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#cd8c86",
        "foreground": "#000000",
        "contrast": 7.69
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c06344",
        "foreground": "#000000",
        "contrast": 5.11
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#b88c51",
        "foreground": "#000000",
        "contrast": 6.91
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#c7c857",
        "foreground": "#000000",
        "contrast": 11.83
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#afd28c",
        "foreground": "#000000",
        "contrast": 12.42
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#53c550",
        "foreground": "#000000",
        "contrast": 9.47
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#55c584",
        "foreground": "#000000",
        "contrast": 9.71
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#88d9bd",
        "foreground": "#000000",
        "contrast": 12.71
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#8bc2d0",
        "foreground": "#000000",
        "contrast": 10.73
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4890c0",
        "foreground": "#000000",
        "contrast": 6.03
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4555b0",
        "foreground": "#ffffff",
        "contrast": 6.61
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#9284ca",
        "foreground": "#000000",
        "contrast": 6.38
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#7943bb",
        "foreground": "#ffffff",
        "contrast": 6.3
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c049b4",
        "foreground": "#000000",
        "contrast": 4.85
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#d481b3",
        "foreground": "#000000",
        "contrast": 7.59
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#be455c",
        "foreground": "#ffffff",
        "contrast": 5.01
      }
    ]
  }
}
